(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-adventskalender"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBbAdv(root) {
      if (!root || root.dataset.bbReady) return;
      root.dataset.bbReady = '1';

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var mobileMq = window.matchMedia('(max-width: 749px)');
      var pauseBtn = root.querySelector('[data-bb-pause]');
      var current = null;

      function pickVideo() {
        var desktop = root.querySelector('.bb-adv-video--desktop');
        var mobile = root.querySelector('.bb-adv-video--mobile');
        if (desktop && desktop.tagName !== 'VIDEO') desktop = desktop.querySelector('video');
        if (mobile && mobile.tagName !== 'VIDEO') mobile = mobile.querySelector('video');
        var want = mobileMq.matches ? (mobile || desktop) : (desktop || mobile);
        [desktop, mobile].forEach(function (v) {
          if (v && v !== want) { v.pause(); }
        });
        current = want;
        if (!current) return;
        current.muted = true;
        current.setAttribute('preload', 'auto');
        if (!reduce && !(pauseBtn && pauseBtn.classList.contains('is-paused'))) {
          var p = current.play();
          if (p && p.catch) p.catch(function () {});
        } else if (pauseBtn) {
          pauseBtn.classList.add('is-paused');
          pauseBtn.setAttribute('aria-label', 'Video abspielen');
        }
      }

      if (pauseBtn) {
        pauseBtn.addEventListener('click', function () {
          if (!current) return;
          if (current.paused) {
            current.play();
            pauseBtn.classList.remove('is-paused');
            pauseBtn.setAttribute('aria-label', 'Video pausieren');
          } else {
            current.pause();
            pauseBtn.classList.add('is-paused');
            pauseBtn.setAttribute('aria-label', 'Video abspielen');
          }
        });
      }

      pickVideo();
      if (mobileMq.addEventListener) mobileMq.addEventListener('change', pickVideo);

      var fitMedia = root.querySelector('.bb-adv-hero--fit-screen .bb-adv-media');
      if (fitMedia) {
        var setOffset = function () {
          var top = fitMedia.getBoundingClientRect().top + window.pageYOffset;
          root.style.setProperty('--bb-hero-offset', Math.max(0, Math.round(top)) + 'px');
        };
        setOffset();
        window.addEventListener('load', setOffset);
        window.addEventListener('resize', setOffset);
      }

      var grads = root.querySelectorAll('.bb-adv-grad');
      if (grads.length) {
        if (!('IntersectionObserver' in window)) {
          grads.forEach(function (el) { el.classList.add('is-in'); });
        } else {
          var gradIo = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                e.target.classList.add('is-in');
                gradIo.unobserve(e.target);
              }
            });
          }, { rootMargin: '0px 0px -25% 0px', threshold: 0.2 });
          grads.forEach(function (el) { gradIo.observe(el); });
        }
      }

      /* Sprunglinks zu Blöcken (#anker oder /aktuelle-seite#anker): weich scrollen, Header berücksichtigen */

      /* Höhe aller Elemente, die oben am Bildschirm fixiert sind bzw. beim Scrollen kleben bleiben
         (z. B. Theme-Header). Gemessen wird, was tatsächlich oben haftet, nicht anhand von Klassennamen. */
      var stickyTopOffset = function () {
        var W = window.innerWidth;
        var offset = 0;
        var all = document.body.querySelectorAll('*');
        for (var i = 0; i < all.length; i++) {
          var el = all[i];
          if (root.contains(el)) continue;
          var cs = getComputedStyle(el);
          if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
          if (cs.display === 'none' || cs.visibility === 'hidden') continue;
          var r = el.getBoundingClientRect();
          if (r.width < W * 0.6 || r.height < 20 || r.height > window.innerHeight * 0.5) continue;
          var bottom;
          if (cs.position === 'sticky') {
            var stickTop = parseFloat(cs.top);
            if (isNaN(stickTop) || stickTop > 40 || r.top > 300) continue;
            bottom = stickTop + r.height;
          } else {
            if (r.top > 10) continue;
            bottom = r.bottom;
          }
          if (bottom > offset) offset = bottom;
        }
        return Math.round(offset);
      };

      /* Zum Element scrollen und nach dem Scrollen nachkorrigieren, falls nachladende Bilder
         den Inhalt verschoben haben. */
      var scrollToEl = function (target, gap) {
        var calc = function () {
          return target.getBoundingClientRect().top + window.pageYOffset - stickyTopOffset() - (gap || 0);
        };
        window.scrollTo({ top: calc(), behavior: reduce ? 'auto' : 'smooth' });
        setTimeout(function () {
          var t = calc();
          if (Math.abs(t - window.pageYOffset) > 4) window.scrollTo({ top: t, behavior: 'auto' });
        }, reduce ? 50 : 900);
      };

      root.addEventListener('click', function (e) {
        var a = e.target.closest('a[href*="#"]');
        if (!a || !root.contains(a)) return;
        var url;
        try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
        if (!url.hash || url.hash === '#bb-adv-buy') return;
        if (url.origin !== window.location.origin || url.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) return;
        var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        if (!target) return;
        e.preventDefault();
        scrollToEl(target, 0);
      });

      /* Produktseite: Kauf-Links springen zum Kaufbereich statt die Seite neu zu laden */
      if (root.hasAttribute('data-bb-product-page')) {
        var findBuyTarget = function () {
          var explicit = document.querySelector('[data-bb-buy-target]');
          if (explicit) return explicit;
          var builder = document.querySelector('[id*="mw_bundle_builder"], [class*="mw-bundleoffer"]');
          if (builder) return builder.closest('.bb-adv-app') || builder.closest('.shopify-section') || builder;
          var forms = document.querySelectorAll('form[action*="/cart/add"]');
          for (var i = 0; i < forms.length; i++) {
            if (!root.contains(forms[i])) {
              return forms[i].closest('.shopify-section') || forms[i];
            }
          }
          return null;
        };
        var scrollToBuy = function () {
          var target = findBuyTarget();
          if (!target) return false;
          scrollToEl(target, 12);
          return true;
        };
        root.addEventListener('click', function (e) {
          var a = e.target.closest('a[href]');
          if (!a || !root.contains(a)) return;
          var href = a.getAttribute('href');
          var url;
          try { url = new URL(href, window.location.href); } catch (err) { return; }
          var samePage = url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');
          var isBuyLink = href === '#bb-adv-buy' || (samePage && (!url.hash || url.hash === '#bb-adv-buy'));
          if (isBuyLink && scrollToBuy()) e.preventDefault();
        });
      }

      /* Kaufleiste des Bundle-Builders (aside.mw-buildoffer) erst zeigen, wenn
         a) der Auswahlbereich erreicht ist oder b) schon ein Schmuckstück gewählt wurde.
         Solange sie verborgen ist, zeigt die Seite ihre eigene Kaufleiste. */
      if (root.hasAttribute('data-bb-product-page')) {
        var docEl = document.documentElement;
        var setupMwBar = function () {
          var aside = document.querySelector('aside.mw-buildoffer');
          var builder = document.querySelector('[id*="mw_bundle_builder"]');
          if (!aside || !builder) return false;
          var picked = function () {
            var m = (aside.innerText || '').match(/(\d+)\s*von\s*\d+/);
            return m ? parseInt(m[1], 10) : 0;
          };
          var ticking = false;
          var update = function () {
            ticking = false;
            var reached = builder.getBoundingClientRect().top < window.innerHeight * 0.85;
            var show = reached || picked() > 0;
            docEl.classList.toggle('bb-mw-bar-hidden', !show);
            docEl.classList.toggle('bb-mw-bar-shown', show);
            /* Solange der Warenkorb-Button in „Mein Adventskalender“ zu sehen ist, bleibt die Leiste weg.
               (Die App blendet sie schon wieder ein, sobald der Titel der Box oben verschwindet.) */
            var mwHost = document.querySelector('mw-build-offer');
            var cartBtn = mwHost && mwHost.shadowRoot && mwHost.shadowRoot.querySelector('.CartContent-Flexy--priceSection .mw-build-offer-add-to-cart');
            var cr = cartBtn ? cartBtn.getBoundingClientRect() : null;
            docEl.classList.toggle('bb-mw-bar-cartvis', !!(cr && cr.height > 0 && cr.bottom > 0 && cr.top < window.innerHeight));
          };
          var request = function () {
            if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
          };
          update();
          window.addEventListener('scroll', request, { passive: true });
          window.addEventListener('resize', request);
          new MutationObserver(request).observe(aside, { subtree: true, childList: true, characterData: true });
          return true;
        };
        if (!setupMwBar()) {
          var mwTries = 0;
          var mwTimer = setInterval(function () {
            if (setupMwBar() || ++mwTries > 40) clearInterval(mwTimer);
          }, 250);
        }
      }

      /* Filterleiste des MW Bundle Builders fixieren. Die Leiste liegt im
         Shadow DOM der App, deshalb wird das CSS dort eingehängt. */
      if (root.hasAttribute('data-bb-mw-sticky-nav')) {
        var headerBottom = function () {
          var max = 0;
          var hs = document.querySelectorAll('.shopify-section-group-header-group, header');
          for (var i = 0; i < hs.length; i++) {
            var cs = getComputedStyle(hs[i]);
            if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
            if (cs.display === 'none' || cs.visibility === 'hidden') continue;
            var r = hs[i].getBoundingClientRect();
            if (r.top <= 1 && r.bottom > max) max = r.bottom;
          }
          return Math.round(max);
        };
        var setupMwNav = function () {
          var host = document.querySelector('mw-build-offer');
          if (!host || !host.shadowRoot) return false;
          var sr = host.shadowRoot;
          var nav = sr.querySelector('nav');
          if (!nav) return false;
          if (!sr.getElementById('bb-mw-nav-style')) {
            var st = document.createElement('style');
            st.id = 'bb-mw-nav-style';
            st.textContent =
              'nav{position:sticky !important;top:var(--bb-mw-nav-top,0px) !important;z-index:20;' +
              'background:var(--bb-mw-nav-bg,#fff) !important;margin-top:14px !important;' +
              'padding-top:10px !important;padding-bottom:10px !important;transition:box-shadow .2s ease;}' +
              'nav[data-bb-stuck]{box-shadow:0 1px 0 rgba(0,0,0,.08);}' +
              /* Leiste auf volle Bildschirmbreite ziehen, Buttons bleiben bündig mit den Produkten. */
              'nav{margin-left:calc(-1 * var(--bb-mw-nav-l,0px)) !important;margin-right:calc(-1 * var(--bb-mw-nav-r,0px)) !important;}' +
              'nav ul{width:auto !important;max-width:none !important;padding-left:var(--bb-mw-nav-l,0px) !important;padding-right:var(--bb-mw-nav-r,0px) !important;scroll-padding-inline:var(--bb-mw-nav-l,0px);}' +
              /* Sprungziele der App (z. B. „Deinen Kalender anzeigen“) nicht unter der Leiste verstecken. */
              '.CartContent-Flexy--header,.Products-Category__CategoryHeader,aside{scroll-margin-top:calc(var(--bb-mw-nav-h,0px) + 12px) !important;}' +
              /* Desktop: Die mitlaufende Zusammenfassung rechts unter der Leiste halten. */
              '.OfferCart--panel.OfferCart--panel{top:calc(var(--bb-mw-nav-top,0px) + var(--bb-mw-nav-h,0px) + 8px) !important;padding-top:4px !important;}' +
              /* Hinweis, dass die Leiste seitlich weitergeht: weicher Übergang + Pfeil am Rand. */
              'nav[data-bb-more-right]::after,nav[data-bb-more-left]::before{content:"";position:absolute;top:0;bottom:0;width:64px;z-index:2;pointer-events:none;}' +
              'nav[data-bb-more-right]::after{right:0;background:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%231a1a1a%27 stroke-width=%272.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M9 18l6-6-6-6%27/%3E%3C/svg%3E\") right 10px center / 18px no-repeat,linear-gradient(to right,rgba(255,255,255,0),var(--bb-mw-nav-bg,#fff) 55%);}' +
              'nav[data-bb-more-left]::before{left:0;background:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%231a1a1a%27 stroke-width=%272.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M15 18l-6-6 6-6%27/%3E%3C/svg%3E\") left 10px center / 18px no-repeat,linear-gradient(to left,rgba(255,255,255,0),var(--bb-mw-nav-bg,#fff) 55%);}';
            sr.appendChild(st);
          }
          var appSec = host.closest('.bb-adv-app');
          var bg = appSec ? getComputedStyle(appSec).backgroundColor : '';
          if (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') bg = getComputedStyle(root).backgroundColor;
          host.style.setProperty('--bb-mw-nav-bg', bg);

          var ticking = false;
          var update = function () {
            ticking = false;
            var top = headerBottom();
            host.style.setProperty('--bb-mw-nav-top', Math.max(0, top - 1) + 'px');
            host.style.setProperty('--bb-mw-nav-h', nav.offsetHeight + 'px');
            var hr = host.getBoundingClientRect();
            var vw = document.documentElement.clientWidth;
            host.style.setProperty('--bb-mw-nav-l', Math.max(0, Math.round(hr.left)) + 'px');
            host.style.setProperty('--bb-mw-nav-r', Math.max(0, Math.round(vw - hr.right)) + 'px');
            var stuck = host.getBoundingClientRect().top < top && nav.getBoundingClientRect().top <= top + 1;
            if (stuck) nav.setAttribute('data-bb-stuck', '');
            else nav.removeAttribute('data-bb-stuck');
          };
          var request = function () {
            if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
          };
          update();
          window.addEventListener('scroll', request, { passive: true });
          window.addEventListener('resize', request);

          /* Pfeile/Verlauf je nach Scrollposition der Leiste ein- und ausblenden. */
          var list = nav.querySelector('ul') || nav;
          var edges = function () {
            var more = list.scrollWidth - list.clientWidth;
            var x = list.scrollLeft;
            if (more > 4 && x < more - 4) nav.setAttribute('data-bb-more-right', ''); else nav.removeAttribute('data-bb-more-right');
            if (more > 4 && x > 4) nav.setAttribute('data-bb-more-left', ''); else nav.removeAttribute('data-bb-more-left');
          };
          list.addEventListener('scroll', edges, { passive: true });
          window.addEventListener('resize', edges);
          edges();
          setTimeout(edges, 600);
          /* Tipp auf einen Pfeil schiebt die Leiste weiter. */
          nav.addEventListener('click', function (e) {
            var r = nav.getBoundingClientRect();
            if (nav.hasAttribute('data-bb-more-right') && e.clientX > r.right - 40) { e.stopPropagation(); e.preventDefault(); list.scrollBy({ left: list.clientWidth * 0.6, behavior: 'smooth' }); }
            else if (nav.hasAttribute('data-bb-more-left') && e.clientX < r.left + 40) { e.stopPropagation(); e.preventDefault(); list.scrollBy({ left: -list.clientWidth * 0.6, behavior: 'smooth' }); }
          }, true);
          /* Einmal kurz anstupsen, wenn die Leiste zum ersten Mal ins Bild kommt. */
          if (window.IntersectionObserver && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
            var nudged = false;
            var io = new IntersectionObserver(function (entries) {
              if (nudged || !entries[0].isIntersecting || !nav.hasAttribute('data-bb-more-right') || list.scrollLeft > 4) return;
              nudged = true;
              io.disconnect();
              setTimeout(function () {
                list.scrollBy({ left: 56, behavior: 'smooth' });
                setTimeout(function () { list.scrollBy({ left: -56, behavior: 'smooth' }); }, 550);
              }, 400);
            }, { threshold: 1 });
            io.observe(nav);
          }

          /* Ein Filter verkürzt die Liste. Wer weiter unten filtert, landet
             sonst hinter dem Ende der Auswahl. Daher zurück an den Anfang. */
          sr.addEventListener('click', function (e) {
            if (e.composedPath().indexOf(nav) === -1) return;
            if (!nav.hasAttribute('data-bb-stuck')) return;
            setTimeout(function () {
              var y = host.getBoundingClientRect().top + window.pageYOffset - headerBottom();
              window.scrollTo({ top: y, behavior: 'auto' });
            }, 60);
          });
          return true;
        };
        if (!setupMwNav()) {
          var navTries = 0;
          var navTimer = setInterval(function () {
            if (setupMwNav() || ++navTries > 40) clearInterval(navTimer);
          }, 250);
        }
      }

      /* Kalenderpreis im Bundle-Builder (Produktkarten und Produkt-Popup) und
         Produktbeschreibung im Popup ausblenden. Die App zeigt nur Einzelpreise.
         Wir rechnen den Rabatt ab und hängen das Ergebnis als Attribut an, die
         Anzeige übernimmt CSS. Die Inhalte der App bleiben unberührt. */
      if (root.hasAttribute('data-bb-mw-cal-percent') || root.hasAttribute('data-bb-mw-hide-desc') || root.hasAttribute('data-bb-mw-swipe') ||
          root.hasAttribute('data-bb-mw-modal-full') || root.hasAttribute('data-bb-mw-modal-close')) {
        var calPercent = parseFloat(root.getAttribute('data-bb-mw-cal-percent')) || 0;
        var calLabel = JSON.stringify(('-' + (parseFloat(root.getAttribute('data-bb-mw-cal-percent')) || 0) + '% ' + (root.getAttribute('data-bb-mw-cal-label') || '')).trim());
        var calColor = getComputedStyle(root).getPropertyValue('--bb-calprice').trim() || '#8B1A1A';

        var calc = function (text) {
          var m = (text || '').match(/\d{1,3}(?:[.\s ]\d{3})*(?:,\d{2})|\d+(?:,\d{2})?/);
          if (!m) return '';
          var cents = Math.round(parseFloat(m[0].replace(/[.\s ]/g, '').replace(',', '.')) * 100);
          if (!cents) return '';
          var c = Math.round(cents * (100 - calPercent) / 100);
          var euros = Math.floor(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          return text.replace(m[0], euros + ',' + ('0' + (c % 100)).slice(-2)).trim();
        };
        /* Karte und Popup: Zeile 1 Kalenderpreis (rot, fett) + Originalpreis durchgestrichen,
           Zeile 2 „-30% im Kalender“. */
        var calCss = function (box, price, orig) {
          var b = box + '[data-bb-cal]';
          return b + '{display:grid !important;grid-template-columns:auto minmax(0,1fr) !important;grid-auto-flow:row !important;' +
            'align-items:baseline !important;justify-content:start !important;column-gap:.4em !important;row-gap:2px !important;height:auto !important;}' +
            b + '::before{content:attr(data-bb-cal);grid-column:1;grid-row:1;font-weight:700;color:var(--bb-calprice,#8B1A1A);}' +
            b + ' ' + price + '{grid-column:2 !important;grid-row:1 !important;margin:0 !important;font-size:1em !important;font-weight:400 !important;' +
            'color:#7C8488 !important;text-decoration:line-through !important;white-space:nowrap;}' +
            b + '::after{content:var(--bb-mw-cal-label,"-30% im Kalender");grid-column:1 / -1;grid-row:2;font-size:.8em;font-weight:600;color:var(--bb-calprice,#8B1A1A);}' +
            b + ' ' + orig + '{display:none !important;}';
        };
        /* Rabatt-Badge in „Mein Adventskalender“, kompakt neben dem Streichpreis. */
        var BB_BADGE = 'content:var(--bb-mw-badge,"-30%");flex:0 0 auto;align-self:center;margin:0;padding:2px 6px;border-radius:9999px;' +
          'font-size:11px;font-weight:600;line-height:14px;color:rgb(66,0,0);background:rgb(253,216,216);white-space:nowrap;text-decoration:none;';
        var calTargets = [
          { id: 'cards', tag: 'mw-build-offer', box: '.Category-ProductCard__PriceContainer', price: '.Category-ProductCard__Price', orig: '.Category-ProductCard__OriginalPrice', extra: '' },
          /* Zusammenfassung „Mein Adventskalender“: Bei 1–4 Teilen zeigt die App nur
             Einzelpreise. Wir ergänzen Kalenderpreis + durchgestrichenen Preis im Stil,
             den die App bei vollem Kalender selbst verwendet. Ab 5 Teilen ändern sich die
             Klassen der App, dann greifen diese Regeln nicht mehr. */
          { id: 'items', tag: 'mw-build-offer', box: '.CartContent-Item--simplePriceContainer', price: '.CartContent-Item--price',
            css: '.CartContent-Item--simplePriceContainer[data-bb-cal]{display:flex !important;align-items:baseline !important;gap:6px !important;}' +
              '.CartContent-Item--simplePriceContainer[data-bb-cal]::before{content:attr(data-bb-cal);font-size:15px;font-weight:700;color:var(--bb-calprice,#8B1A1A);}' +
              '.CartContent-Item--simplePriceContainer[data-bb-cal] .CartContent-Item--price{font-size:15px !important;font-weight:400 !important;color:#7C8488 !important;text-decoration:line-through !important;}' +
              /* Rabatt-Badge rechts neben dem Streichpreis (kompakte Zeilen, siehe bb-mw-item-style). */
              '.CartContent-Item--simplePriceContainer.CartContent-Item--simplePriceContainer[data-bb-cal]{column-gap:4px !important;}' +
              '.CartContent-Item--simplePriceContainer[data-bb-cal]::after{' + BB_BADGE + '}' },
          { id: 'total', tag: 'mw-build-offer', box: '.CartContent-Price__PriceText', price: '.CartContent-Price__PriceAmount',
            css: '.CartContent-Price__PriceText[data-bb-cal]{display:flex !important;flex-wrap:wrap;justify-content:flex-end;align-items:baseline !important;column-gap:6px;}' +
              '.CartContent-Price__PriceText[data-bb-cal]::after{content:attr(data-bb-cal);order:1;font-size:20px;font-weight:600;color:#1A1C1D;}' +
              '.CartContent-Price__PriceText[data-bb-cal] .CartContent-Price__PriceAmount{order:2;font-size:14px !important;font-weight:400 !important;color:#7C8488 !important;text-decoration:line-through !important;}' },
          { id: 'modal', tag: 'mw-offers-dialog', box: '.Products-ProductInfoModal--modalPriceContainer', price: '.Products-ProductInfoModal--modalPrice', orig: '.Products-ProductInfoModal--modalOriginalPrice',
            /* Produkttitel nicht verlinken, damit niemand die Kalenderseite verlässt.
               Fokus-Rahmen nur bei Tastaturbedienung zeigen (die App setzt beim Öffnen den Fokus). */
            extra: ':host(:not([data-bb-kbd])) *:focus,:host(:not([data-bb-kbd])) *:focus-visible{outline:none !important;box-shadow:none !important;}' +
              '.Products-ProductInfoModal--modalProductTitle{pointer-events:none !important;cursor:default !important;text-decoration:none !important;color:inherit !important;}' +
              (root.hasAttribute('data-bb-mw-hide-desc') ? '.Products-ProductInfoModal--modalProductDescription{display:none !important;}' : '') +
              (root.hasAttribute('data-bb-mw-swipe') ?
                /* Mobil: Vorschaubilder werden zu Punkten, das große Bild lässt sich wischen.
                   Desktop: Vorschaubilder bleiben als Miniaturen unter dem Bild. */
                '@media (max-width: 989px){' +
                '.Products-ProductInfoModal--modalThumbnails{justify-content:center !important;flex-wrap:wrap !important;gap:6px !important;margin-top:12px !important;}' +
                '.Products-ProductInfoModal--modalThumbnailButton{width:7px !important;height:7px !important;min-width:0 !important;min-height:0 !important;flex:0 0 7px !important;' +
                'padding:0 !important;margin:0 !important;border:0 !important;outline:0 !important;border-radius:50% !important;background:#d4d4d4 !important;overflow:hidden !important;box-shadow:none !important;}' +
                '.Products-ProductInfoModal--modalThumbnailButton img{display:none !important;}' +
                '.Products-ProductInfoModal--modalThumbnailActive{background:#1a1a1a !important;}' +
                /* Eigene Bildleiste mit Scroll-Snap wie auf der Produktseite: Das Bild folgt dem Finger. */
                '.Products-ProductInfoModal--modalImageContainer[data-bb-slider]{position:relative !important;}' +
                '.Products-ProductInfoModal--modalImageContainer[data-bb-slider] > img{visibility:hidden !important;}' +
                '.bb-slide-track{position:absolute;inset:0;z-index:1;pointer-events:auto;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;' +
                'scrollbar-width:none;-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;touch-action:pan-x;}' +
                '.bb-slide-track::-webkit-scrollbar{display:none;}' +
                '.bb-slide{flex:0 0 100%;width:100%;height:100%;scroll-snap-align:center;scroll-snap-stop:always;display:flex;align-items:center;justify-content:center;}' +
                '.bb-slide img{width:100%;height:100%;object-fit:contain;display:block;-webkit-user-drag:none;user-select:none;-webkit-user-select:none;}' +
                '}' +
                '@media (min-width: 990px){' +
                '.Products-ProductInfoModal--modalThumbnails{display:flex !important;flex-wrap:wrap !important;gap:8px !important;overflow:visible !important;' +
                'justify-content:flex-start !important;margin:12px 0 0 !important;padding:0 20px !important;}' +
                '.Products-ProductInfoModal--modalThumbnailButton{flex:0 0 56px !important;width:56px !important;height:56px !important;padding:0 !important;margin:0 !important;' +
                'border:1px solid #e5e5e5 !important;border-radius:6px !important;overflow:hidden !important;cursor:pointer;background:#fff !important;}' +
                '.Products-ProductInfoModal--modalThumbnailButton img{width:100% !important;height:100% !important;object-fit:cover !important;display:block !important;}' +
                '.Products-ProductInfoModal--modalThumbnailActive{border:2px solid #1a1a1a !important;}' +
                /* Das Bild ist bis zu 600 px hoch und wird nur so weit kleiner, wie Miniaturen, Titel,
                   Preis, Größe und Button sonst nicht auf den Bildschirm passen. */
                /* Doppelte Klassen, damit diese Regeln die allgemeinen Popup-Regeln weiter unten schlagen. */
                '.Modal__Content.Modal__Content{display:flex !important;flex-direction:column !important;' +
                'max-height:calc(100vh - 80px) !important;max-height:calc(100dvh - 80px) !important;}' +
                '.Modal > div.min-h-screen, .Modal > div{padding:40px 0 !important;}' +
                '.Products-ProductInfoModal--modalContent.Products-ProductInfoModal--modalContent{flex:1 1 auto !important;min-height:0 !important;}' +
                '.Products-ProductInfoModal--modalGallery.Products-ProductInfoModal--modalGallery{flex:1 1 auto !important;min-height:0 !important;display:flex !important;flex-direction:column !important;}' +
                '.Products-ProductInfoModal--modalImageContainer.Products-ProductInfoModal--modalImageContainer{flex:0 1 600px !important;height:auto !important;min-height:200px !important;}' +
                '.Products-ProductInfoModal--modalThumbnails{flex:none !important;}' +
                /* Pfeile links und rechts auf dem Hauptbild (nur bei mehreren Bildern), ohne Hintergrund.
                   Ein feiner heller Schein hält sie auch auf dunklen Fotos sichtbar. */
                '.Products-ProductInfoModal--modalImageContainer.Products-ProductInfoModal--modalImageContainer{position:relative !important;}' +
                '.Products-ProductInfoModal--modalGallery:has(.Products-ProductInfoModal--modalThumbnailButton + .Products-ProductInfoModal--modalThumbnailButton) .Products-ProductInfoModal--modalImageContainer::before,' +
                '.Products-ProductInfoModal--modalGallery:has(.Products-ProductInfoModal--modalThumbnailButton + .Products-ProductInfoModal--modalThumbnailButton) .Products-ProductInfoModal--modalImageContainer::after{' +
                'content:"";position:absolute;top:50%;width:40px;height:40px;margin-top:-20px;border-radius:50%;z-index:2;pointer-events:none;' +
                'background:transparent center / 30px no-repeat;filter:drop-shadow(0 0 2px rgba(255,255,255,.95)) drop-shadow(0 0 1px rgba(255,255,255,.95));}' +
                '.Products-ProductInfoModal--modalImageContainer::before{left:6px;background-image:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%231a1a1a%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M15 18l-6-6 6-6%27/%3E%3C/svg%3E") !important;}' +
                '.Products-ProductInfoModal--modalImageContainer::after{right:6px;background-image:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%231a1a1a%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M9 18l6-6-6-6%27/%3E%3C/svg%3E") !important;}' +
                '}'
                : '') +
              (root.hasAttribute('data-bb-mw-modal-full') ?
                /* Mobil und Desktop gleich aufgebaut: Bild oben über die volle Breite, darunter Titel,
                   Preis und Button. Am Desktop höchstens 600 px breit. */
                '.Modal__Content{width:calc(100% - 30px) !important;max-width:600px !important;margin-left:auto !important;margin-right:auto !important;position:relative !important;}' +
                '.Products-ProductInfoModal--modalContent{display:flex !important;flex-direction:column !important;gap:12px !important;}' +
                '.Products-ProductInfoModal--modalGallery,.Products-ProductInfoModal--modalInfoContainer{flex:none !important;width:100% !important;max-width:none !important;}' +
                '.Products-ProductInfoModal--modalHeader{position:absolute !important;top:0 !important;right:0 !important;padding:10px !important;z-index:3 !important;}' +
                '.Products-ProductInfoModal--modalCloseButton{width:36px !important;height:36px !important;border-radius:50% !important;background:rgba(255,255,255,.85) !important;' +
                'display:flex !important;align-items:center !important;justify-content:center !important;box-shadow:0 1px 4px rgba(0,0,0,.12) !important;}' +
                '.Products-ProductInfoModal--modalContent{padding:0 0 20px !important;}' +
                '.Products-ProductInfoModal--modalGallery{width:100% !important;margin:0 !important;}' +
                /* Bild vollständig (1:1): so groß wie die Breite erlaubt, aber nie höher, als neben Titel, Preis und Button Platz ist. */
                '.Products-ProductInfoModal--modalImageContainer{width:100% !important;height:max(200px, min(calc(100vw - 30px), 600px, calc(100dvh - 260px))) !important;' +
                'max-height:none !important;margin:0 !important;display:flex !important;align-items:center !important;justify-content:center !important;}' +
                '.Products-ProductInfoModal--modalImage{width:100% !important;height:100% !important;max-height:none !important;object-fit:contain !important;display:block;}' +
                /* Stärker abdunkeln, mittig fixieren, nicht mitscrollen. */
                '.Modal{overflow:hidden !important;overscroll-behavior:contain !important;padding:0 !important;}' +
                '.Modal__Overlay{background-color:#000 !important;opacity:.6 !important;}' +
                '.Modal > div{display:flex !important;align-items:center !important;justify-content:center !important;min-height:0 !important;height:100dvh !important;padding:8px 0 !important;box-sizing:border-box !important;}' +
                '.Modal > div > span{display:none !important;}' +
                '.Modal__Content{max-height:calc(100dvh - 16px) !important;overflow-y:auto !important;overscroll-behavior:contain !important;}' +
                '.Products-ProductInfoModal--modalInfoContainer{padding-left:20px !important;padding-right:20px !important;}' +
                /* Button bzw. Plus/Minus-Regler über die volle Breite. */
                '.Products-ProductInfoModal--modalActions{display:flex !important;width:100% !important;}' +
                '.Products-ProductInfoModal--modalActions > *{flex:1 1 auto !important;width:100% !important;max-width:none !important;}' +
                '.Products-ProductInfoModal--modalActions .Category-ProductCard__QuantityContainer{justify-content:space-between !important;}'
                : ''),
            swipe: root.hasAttribute('data-bb-mw-swipe'),
            autoClose: root.hasAttribute('data-bb-mw-modal-close'),
            lock: root.hasAttribute('data-bb-mw-modal-full') }
        ];
        var setupSwipe = function (sr) {
          var BOX = 'Products-ProductInfoModal--modalImageContainer';
          var THUMB = '.Products-ProductInfoModal--modalThumbnailButton';
          var ACTIVE = 'Products-ProductInfoModal--modalThumbnailActive';
          var activeIndex = function (thumbs) {
            for (var i = 0; i < thumbs.length; i++) {
              if (thumbs[i].classList.contains(ACTIVE)) return i;
            }
            return 0;
          };
          var build = function () {
            var box = sr.querySelector('.' + BOX);
            if (!box) return;
            var track = box.querySelector('.bb-slide-track');
            var gallery = box.closest('.Products-ProductInfoModal--modalGallery');
            var thumbs = gallery ? gallery.querySelectorAll(THUMB) : [];
            if (window.innerWidth > 989 || thumbs.length < 2) {
              if (track) track.remove();
              box.removeAttribute('data-bb-slider');
              return;
            }
            var srcs = [];
            for (var i = 0; i < thumbs.length; i++) {
              var ti = thumbs[i].querySelector('img');
              srcs.push(ti ? ti.getAttribute('src') : '');
            }
            var titleEl = sr.querySelector('.Products-ProductInfoModal--modalProductTitle');
            var key = (titleEl ? titleEl.textContent : '') + '#' + srcs.join('|');
            if (track && track.getAttribute('data-key') === key) return;
            if (track) track.remove();
            track = document.createElement('div');
            track.className = 'bb-slide-track';
            track.setAttribute('data-key', key);
            srcs.forEach(function (src, n) {
              var slide = document.createElement('div');
              slide.className = 'bb-slide';
              var im = document.createElement('img');
              im.src = src;
              im.alt = '';
              im.draggable = false;
              if (n > 1) im.loading = 'lazy';
              slide.appendChild(im);
              track.appendChild(slide);
            });
            box.appendChild(track);
            box.setAttribute('data-bb-slider', '');
            var startIdx = activeIndex(thumbs);
            track.scrollLeft = startIdx * track.clientWidth;
            /* Das Popup blendet mit einer Skalierung ein. Position nach dem Layout nochmals setzen. */
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(function () { track.scrollLeft = startIdx * track.clientWidth; });
            });

            /* Nach dem Wischen den passenden Punkt der App aktivieren. */
            var timer;
            track.addEventListener('scroll', function () {
              clearTimeout(timer);
              timer = setTimeout(function () {
                var w = track.clientWidth || 1;
                var idx = Math.round(track.scrollLeft / w);
                var th = gallery.querySelectorAll(THUMB);
                if (th[idx] && !th[idx].classList.contains(ACTIVE)) th[idx].click();
              }, 90);
            }, { passive: true });
          };
          /* Tipp auf einen Punkt: Bildleiste dorthin schieben. */
          sr.addEventListener('click', function (e) {
            var path = e.composedPath();
            var btn = null;
            for (var i = 0; i < path.length; i++) {
              if (path[i].matches && path[i].matches(THUMB)) { btn = path[i]; break; }
            }
            if (!btn) return;
            var gallery = btn.closest('.Products-ProductInfoModal--modalGallery');
            var track = gallery && gallery.querySelector('.bb-slide-track');
            if (!track) return;
            var idx = Array.prototype.indexOf.call(gallery.querySelectorAll(THUMB), btn);
            var target = idx * track.clientWidth;
            if (Math.abs(track.scrollLeft - target) > 2) track.scrollTo({ left: target, behavior: 'smooth' });
          });
          var pending = false;
          new MutationObserver(function () {
            if (pending) return;
            pending = true;
            window.requestAnimationFrame(function () { pending = false; build(); });
          }).observe(sr, { subtree: true, childList: true });
          window.addEventListener('resize', build);
          build();
        };
        var attachCal = function (t) {
          var host = document.querySelector(t.tag);
          if (!host || !host.shadowRoot) return false;
          var flag = 'data-bb-cal-' + t.id;
          if (host.hasAttribute(flag)) return true;
          host.setAttribute(flag, '');
          var sr = host.shadowRoot;
          var st = document.createElement('style');
          st.textContent = (calPercent > 0 ? (t.css || calCss(t.box, t.price, t.orig)) : '') + (t.extra || '');
          sr.appendChild(st);
          host.style.setProperty('--bb-calprice', calColor);
          host.style.setProperty('--bb-mw-cal-label', calLabel);
          host.style.setProperty('--bb-mw-badge', JSON.stringify('-' + calPercent + '%'));
          if (t.swipe) setupSwipe(sr);
          if (t.id === 'modal') {
            /* Tastatur erkannt: Fokus-Rahmen wieder erlauben. Bei Maus oder Touch ausblenden. */
            document.addEventListener('keydown', function (e) {
              if (e.key === 'Tab') host.setAttribute('data-bb-kbd', '');
            }, true);
            document.addEventListener('pointerdown', function () {
              host.removeAttribute('data-bb-kbd');
            }, true);
            /* Desktop: Klick auf den linken bzw. rechten Pfeil im Hauptbild. Die Pfeile sind
               Teil des Bildbereichs, daher zählt die Position des Klicks. */
            sr.addEventListener('click', function (e) {
              if (window.innerWidth <= 989) return;
              var path = e.composedPath();
              var box = null;
              for (var i = 0; i < path.length; i++) {
                if (path[i].classList && path[i].classList.contains('Products-ProductInfoModal--modalImageContainer')) { box = path[i]; break; }
              }
              if (!box) return;
              var r = box.getBoundingClientRect();
              var dir = e.clientX < r.left + 64 ? -1 : (e.clientX > r.right - 64 ? 1 : 0);
              if (!dir) return;
              var gallery = box.closest('.Products-ProductInfoModal--modalGallery');
              var thumbs = gallery ? gallery.querySelectorAll('.Products-ProductInfoModal--modalThumbnailButton') : [];
              if (thumbs.length < 2) return;
              var idx = 0;
              for (var k = 0; k < thumbs.length; k++) {
                if (thumbs[k].classList.contains('Products-ProductInfoModal--modalThumbnailActive')) { idx = k; break; }
              }
              e.preventDefault();
              thumbs[(idx + dir + thumbs.length) % thumbs.length].click();
            }, true);
            /* Hand-Cursor über den Pfeilen. */
            sr.addEventListener('mousemove', function (e) {
              if (window.innerWidth <= 989) return;
              var path = e.composedPath();
              for (var i = 0; i < path.length; i++) {
                if (path[i].classList && path[i].classList.contains('Products-ProductInfoModal--modalImageContainer')) {
                  var r = path[i].getBoundingClientRect();
                  var edge = e.clientX < r.left + 64 || e.clientX > r.right - 64;
                  path[i].style.cursor = edge ? 'pointer' : '';
                  return;
                }
              }
            });
            /* Sicherheitsnetz zum Titel-Link (z. B. Tastatur): Navigation verhindern. */
            sr.addEventListener('click', function (e) {
              var path = e.composedPath();
              for (var i = 0; i < path.length; i++) {
                if (path[i].classList && path[i].classList.contains('Products-ProductInfoModal--modalProductTitle')) { e.preventDefault(); return; }
              }
            }, true);
            var titleLink = sr.querySelector('.Products-ProductInfoModal--modalProductTitle');
            if (titleLink) titleLink.setAttribute('tabindex', '-1');
            /* Bei Teilen, die schon im Kalender sind, setzt die App den Fokus beim Öffnen
               auf das Mengenfeld. Auf dem iPhone blockiert ein fokussiertes Eingabefeld das
               Wischen durch die Bilder. Fokus entfernen, außer die Kundin tippt selbst hinein. */
            var lastDown = { el: null, at: 0 };
            sr.addEventListener('pointerdown', function (e) {
              lastDown.el = e.composedPath()[0];
              lastDown.at = Date.now();
            }, true);
            sr.addEventListener('focusin', function (e) {
              var el = e.composedPath()[0];
              if (!el || !el.classList || !el.classList.contains('Category-ProductCard__QuantityDisplay')) return;
              if (lastDown.el === el && Date.now() - lastDown.at < 800) return;
              setTimeout(function () { if (sr.activeElement === el) el.blur(); }, 0);
            });
            /* Sicherheitsnetz: Beim Berühren der Bilder ein noch fokussiertes Feld lösen. */
            sr.addEventListener('touchstart', function (e) {
              var a = sr.activeElement;
              if (!a || (a.tagName !== 'INPUT' && a.tagName !== 'SELECT')) return;
              var path = e.composedPath();
              for (var i = 0; i < path.length; i++) {
                if (path[i].classList && path[i].classList.contains('Products-ProductInfoModal--modalGallery')) { a.blur(); return; }
              }
            }, { passive: true, capture: true });
          }
          if (t.lock) {
            /* iOS: Wischen auf dem Popup darf die Seite dahinter nicht verschieben.
               Erlaubt bleibt nur Scrollen im Popup, falls es auf sehr kleinen Handys nicht ganz passt. */
            sr.addEventListener('touchmove', function (e) {
              if (window.innerWidth > 989) return;
              var path = e.composedPath();
              for (var i = 0; i < path.length; i++) {
                var el = path[i];
                if (el.classList && el.classList.contains('bb-slide-track')) return;
                if (el.classList && el.classList.contains('Modal__Content')) {
                  if (el.scrollHeight > el.clientHeight + 1) return;
                  break;
                }
              }
              if (e.cancelable) e.preventDefault();
            }, { passive: false });
          }
          if (t.autoClose) {
            /* Nach „In den Kalender“ im Popup das Popup schließen. */
            sr.addEventListener('click', function (e) {
              var path = e.composedPath();
              var hit = false;
              for (var i = 0; i < path.length; i++) {
                var el = path[i];
                if (el.classList && el.classList.contains('Products-ProductInfoModal--modalActions')) { hit = true; break; }
              }
              if (!hit) return;
              /* Nur der Hinzufügen-Button, nicht die Plus/Minus-Buttons danach. */
              var btn = null;
              for (var j = 0; j < path.length; j++) {
                if (path[j].tagName === 'BUTTON') { btn = path[j]; break; }
              }
              if (!btn || btn.disabled || !btn.classList.contains('Category-ProductCard__Button')) return;
              setTimeout(function () {
                var close = sr.querySelector('.Products-ProductInfoModal--modalCloseButton');
                if (close) close.click();
              }, root.hasAttribute('data-bb-mw-added') ? 450 : 350);
            }, true);
          }
          if (calPercent <= 0) return true;

          var ticking = false;
          var apply = function () {
            ticking = false;
            var boxes = sr.querySelectorAll(t.box);
            for (var i = 0; i < boxes.length; i++) {
              var priceEl = boxes[i].querySelector(t.price);
              var val = priceEl ? calc(priceEl.textContent) : '';
              if (val) {
                if (boxes[i].getAttribute('data-bb-cal') !== val) boxes[i].setAttribute('data-bb-cal', val);
              } else if (boxes[i].hasAttribute('data-bb-cal')) {
                boxes[i].removeAttribute('data-bb-cal');
              }
            }
          };
          var request = function () {
            if (!ticking) { ticking = true; window.requestAnimationFrame(apply); }
          };
          apply();
          /* Auch Klassenwechsel beobachten: Die App baut Elemente beim Wechsel zwischen
             4 und 5 Teilen teils nur über die Klasse um. */
          new MutationObserver(request).observe(sr, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
          return true;
        };
        var attachAllCal = function () {
          var ok = true;
          for (var i = 0; i < calTargets.length; i++) {
            if (!attachCal(calTargets[i])) ok = false;
          }
          return ok;
        };
        if (!attachAllCal()) {
          /* Das Produkt-Popup legt die App erst beim ersten Öffnen an. */
          var calTries = 0;
          var calTimer = setInterval(function () {
            if (attachAllCal() || ++calTries > 40) clearInterval(calTimer);
          }, 250);
          var onCalClick = function () {
            setTimeout(function () {
              if (attachAllCal()) document.removeEventListener('click', onCalClick, true);
            }, 50);
          };
          document.addEventListener('click', onCalClick, true);
        }

        /* Untere MW-Leiste: Die App zeigt den rabattierten Gesamtpreis erst bei
           vollem Kalender. Bis dahin ergänzen wir ihn selbst. Sobald die App
           ihre eigenen zwei Preise zeigt, nehmen wir uns wieder raus. */
        if (calPercent > 0) {
          /* Die Leiste liegt außerhalb der Section, deshalb die Farbe global bereitstellen. */
          document.documentElement.style.setProperty('--bb-calprice', calColor);
          document.documentElement.style.setProperty('--bb-mw-badge', JSON.stringify('-' + calPercent + '%'));
          document.documentElement.setAttribute('data-bb-badge', '');
          var setupBarCal = function () {
            var aside = document.querySelector('aside.mw-buildoffer');
            if (!aside) return false;
            var barTicking = false;
            var applyBar = function () {
              barTicking = false;
              var right = aside.querySelector('.mw-bundleoffer__header-right');
              if (!right) return;
              var priced = 0;
              var kids = right.children;
              for (var i = 0; i < kids.length; i++) {
                if (/\d/.test(kids[i].textContent)) priced++;
              }
              var fin = right.querySelector('.mw-bundleoffer__price-final');
              var val = (priced === 1 && fin) ? calc(fin.textContent) : '';
              if (val) {
                if (right.getAttribute('data-bb-cal') !== val) right.setAttribute('data-bb-cal', val);
              } else if (right.hasAttribute('data-bb-cal')) {
                right.removeAttribute('data-bb-cal');
              }
            };
            applyBar();
            new MutationObserver(function () {
              if (!barTicking) { barTicking = true; window.requestAnimationFrame(applyBar); }
            }).observe(aside, { subtree: true, childList: true, characterData: true });
            return true;
          };
          if (!setupBarCal()) {
            var barTries = 0;
            var barTimer = setInterval(function () {
              if (setupBarCal() || ++barTries > 40) clearInterval(barTimer);
            }, 250);
          }
        }
      }

      /* Aufklappbarer Hinweis (z. B. Ringgrößen) im Produkt-Popup, nur bei passenden Produkten. */
      var noteTpl = root.querySelector('template[data-bb-ring-note]');
      if (noteTpl) {
        var noteWords = (noteTpl.getAttribute('data-match') || '').split(',').map(function (w) {
          return w.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }).filter(Boolean);
        var noteRe = noteWords.length ? new RegExp('(^|[^a-zäöüß])(' + noteWords.join('|') + ')([^a-zäöüß]|$)', 'i') : null;
        var noteTitle = noteTpl.getAttribute('data-title') || '';
        var noteHtml = noteTpl.innerHTML;
        var setupNote = function () {
          var host = document.querySelector('mw-offers-dialog');
          if (!host || !host.shadowRoot || !noteRe) return false;
          var sr = host.shadowRoot;
          if (!sr.getElementById('bb-note-style')) {
            var st = document.createElement('style');
            st.id = 'bb-note-style';
            st.textContent =
              '.bb-note{border-top:1px solid #d9d9d9;border-bottom:1px solid #d9d9d9;margin:4px 0 0;text-align:left;}' +
              '.bb-note summary{list-style:none;cursor:pointer;display:flex;justify-content:space-between;align-items:center;gap:12px;padding:14px 0;font-size:15px;font-weight:600;line-height:1.4;}' +
              '.bb-note summary::-webkit-details-marker{display:none;}' +
              '.bb-note summary::after{content:"+";font-size:20px;font-weight:400;line-height:1;transition:transform .2s ease;}' +
              '.bb-note[open] summary::after{transform:rotate(45deg);}' +
              '.bb-note__body{padding:0 0 14px;font-size:14px;line-height:1.6;color:#333;}' +
              '.bb-note__body p{margin:0 0 .8em;}.bb-note__body p:last-child{margin-bottom:0;}';
            sr.appendChild(st);
          }
          var pending = false;
          var place = function () {
            pending = false;
            var info = sr.querySelector('.Products-ProductInfoModal--modalInfoContainer');
            var existing = sr.querySelector('.bb-note');
            if (!info) return;
            var t = info.querySelector('.Products-ProductInfoModal--modalProductTitle');
            var match = t && noteRe.test(t.textContent);
            if (!match) { if (existing) existing.remove(); return; }
            if (existing && existing.parentElement === info && existing.getAttribute('data-for') === t.textContent) return;
            if (existing) existing.remove();
            var d = document.createElement('details');
            d.className = 'bb-note';
            d.setAttribute('data-for', t.textContent);
            var sm = document.createElement('summary');
            sm.textContent = noteTitle;
            var body = document.createElement('div');
            body.className = 'bb-note__body';
            body.innerHTML = noteHtml;
            d.appendChild(sm);
            d.appendChild(body);
            var actions = info.querySelector('.Products-ProductInfoModal--modalActions');
            if (actions) info.insertBefore(d, actions); else info.appendChild(d);
          };
          new MutationObserver(function () {
            if (!pending) { pending = true; window.requestAnimationFrame(place); }
          }).observe(sr, { subtree: true, childList: true, characterData: true });
          place();
          return true;
        };
        if (!setupNote()) {
          var noteTries = 0;
          var noteTimer = setInterval(function () {
            if (setupNote() || ++noteTries > 40) clearInterval(noteTimer);
          }, 250);
        }
      }

      /* „Mein Adventskalender“: Lieferhinweis über und Vorteile unter dem Warenkorb-Button,
         im Stil der Produktseite. */
      var cartTpl = root.querySelector('template[data-bb-cart-extras]');
      if (cartTpl) {
        var stockText = cartTpl.getAttribute('data-stock') || '';
        var uspHtml = cartTpl.innerHTML;
        var hasUsps = /<li>/.test(uspHtml);
        var CHECK = '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" fill="#00892a"><path d="M5.341,12.247a1,1,0,0,0,1.317,1.505l4-3.5a1,1,0,0,0,.028-1.48l-9-8.5A1,1,0,0,0,.313,1.727l8.2,7.745Z" transform="translate(19 6.5) rotate(90)"/></svg>';
        var setupCartExtras = function () {
          var host = document.querySelector('mw-build-offer');
          if (!host || !host.shadowRoot) return false;
          var sr = host.shadowRoot;
          if (!sr.getElementById('bb-cart-extras-style')) {
            var st = document.createElement('style');
            st.id = 'bb-cart-extras-style';
            st.textContent =
              '.bb-stock{display:flex;align-items:center;gap:8px;margin:0 0 -6px;font-size:14px;line-height:1.4;color:#307A07;text-align:left;}' +
              '.bb-stock::before{content:"";flex:0 0 9px;width:9px;height:9px;border-radius:50%;background:#009900;}' +
              '.bb-usps{list-style:none;margin:-4px 0 0;padding:0;text-align:left;}' +
              '.bb-usps li{display:flex;align-items:center;gap:6px;font-size:14px;font-weight:700;line-height:1.65;color:#008000;}' +
              '.bb-usps svg{flex:0 0 22px;}';
            sr.appendChild(st);
          }
          var pending = false;
          var place = function () {
            pending = false;
            var btn = sr.querySelector('.CartContent-Flexy--priceSection .mw-build-offer-add-to-cart');
            if (!btn) return;
            var wrap = btn.parentElement;
            var section = wrap.parentElement;
            if (stockText) {
              var stock = section.querySelector(':scope > .bb-stock');
              if (!stock || stock.nextElementSibling !== wrap) {
                if (stock) stock.remove();
                stock = document.createElement('p');
                stock.className = 'bb-stock';
                stock.textContent = stockText;
                section.insertBefore(stock, wrap);
              }
            }
            if (hasUsps) {
              var list = section.querySelector(':scope > .bb-usps');
              if (!list || list.previousElementSibling !== wrap) {
                if (list) list.remove();
                var tmp = document.createElement('div');
                tmp.innerHTML = uspHtml;
                list = tmp.querySelector('ul');
                list.className = 'bb-usps';
                var lis = list.querySelectorAll('li');
                for (var i = 0; i < lis.length; i++) lis[i].insertAdjacentHTML('afterbegin', CHECK);
                section.insertBefore(list, wrap.nextSibling);
              }
            }
          };
          new MutationObserver(function () {
            if (!pending) { pending = true; window.requestAnimationFrame(place); }
          }).observe(sr, { subtree: true, childList: true });
          place();
          return true;
        };
        if (!setupCartExtras()) {
          var cartTries = 0;
          var cartTimer = setInterval(function () {
            if (setupCartExtras() || ++cartTries > 40) clearInterval(cartTimer);
          }, 250);
        }
      }

      /* Bildergalerie: Pfeile am Desktop, ausgeblendet am Anfang bzw. Ende der Reihe. */
      root.querySelectorAll('[data-bb-gallery]').forEach(function (gal) {
        if (gal.hasAttribute('data-bb-gallery-ready')) return;
        gal.setAttribute('data-bb-gallery-ready', '');
        var track = gal.querySelector('.bb-adv-gallery__track');
        var prev = gal.querySelector('[data-bb-gallery-prev]');
        var next = gal.querySelector('[data-bb-gallery-next]');
        if (!track || !prev || !next) return;
        var queued = false;
        var update = function () {
          queued = false;
          var max = track.scrollWidth - track.clientWidth;
          prev.hidden = track.scrollLeft <= 4;
          next.hidden = track.scrollLeft >= max - 4;
        };
        var queue = function () {
          if (!queued) { queued = true; window.requestAnimationFrame(update); }
        };
        var step = function (dir) {
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        };
        prev.addEventListener('click', function () { step(-1); });
        next.addEventListener('click', function () { step(1); });
        track.addEventListener('scroll', queue, { passive: true });
        window.addEventListener('resize', queue);
        update();
        setTimeout(update, 600);
      });

      /* „Beliebt im Kalender“ & Bildergalerie: Klick auf ein Produkt öffnet das Produkt-Popup des
         Bundle-Builders, ohne zur Auswahl zu springen.
         Der Builder zeigt pro Kategorie zuerst nur 12 Produkte und lädt weitere erst, wenn man
         ans Ende scrollt (unsichtbarer 1-px-„Sentinel“). Fehlt die Karte noch, schieben wir diese
         Sentinels kurz per transform ins Bild, damit die App nachlädt, und suchen dann erneut.
         Gibt es das Produkt im Builder gar nicht, bleibt es beim normalen Link. */
      if (root.hasAttribute('data-bb-product-page')) {
        var mwSr = function () {
          var host = document.querySelector('mw-build-offer');
          return host && host.shadowRoot;
        };
        var mwFindCard = function (sr, pid) {
          var cards = sr.querySelectorAll('article.Category-ProductCard[id$="-' + pid + '"]');
          if (!cards.length) return null;
          for (var i = 0; i < cards.length; i++) {
            if (cards[i].querySelector('.Category-ProductCard__QuantityContainer')) return cards[i];
          }
          return cards[0];
        };
        var mwLoading = null;
        /* Lädt so lange nach, bis alle gesuchten Produkte da sind oder nichts mehr kommt. */
        var mwLoadUntil = function (sr, pids) {
          var missing = function () {
            return pids.filter(function (p) { return !mwFindCard(sr, p); });
          };
          if (!missing().length) return Promise.resolve();
          if (mwLoading) return mwLoading.then(function () { return missing().length ? mwLoadUntil(sr, pids) : null; });
          var count = function () { return sr.querySelectorAll('article.Category-ProductCard').length; };
          mwLoading = new Promise(function (resolve) {
            var rounds = 0;
            var round = function () {
              var sents = sr.querySelectorAll('.Products-Category__Sentinel');
              if (!missing().length || !sents.length || ++rounds > 25) { resolve(); return; }
              var before = count();
              for (var i = 0; i < sents.length; i++) {
                var r = sents[i].getBoundingClientRect();
                sents[i].style.transform = 'translateY(' + Math.round(window.innerHeight / 2 - r.top) + 'px)';
              }
              var waited = 0;
              var poll = setInterval(function () {
                waited += 100;
                if (count() > before || waited >= 3000) {
                  clearInterval(poll);
                  for (var j = 0; j < sents.length; j++) sents[j].style.transform = '';
                  if (count() > before) round(); else resolve();
                }
              }, 100);
            };
            round();
          }).then(function () { mwLoading = null; });
          return mwLoading;
        };
        var mwOpen = function (card) {
          var opener = card.querySelector('.Category-ProductCard__ProductTitle, .Category-ProductCard__ImageContainer');
          if (opener) opener.click();
          return !!opener;
        };

        root.addEventListener('click', function (e) {
          var link = e.target.closest('.bb-adv-pcard[data-bb-pid], .bb-adv-gallery__item[data-bb-pid]');
          if (!link || !root.contains(link) || link.hasAttribute('data-bb-fallback')) return;
          var sr = mwSr();
          if (!sr) return;
          var pid = link.getAttribute('data-bb-pid');
          /* Vor den Sprung-Links der Section abfangen (Capture), damit nicht gescrollt wird. */
          e.preventDefault();
          e.stopPropagation();
          var card = mwFindCard(sr, pid);
          if (card && mwOpen(card)) return;
          link.setAttribute('aria-busy', 'true');
          mwLoadUntil(sr, [pid]).then(function () {
            link.removeAttribute('aria-busy');
            var found = mwFindCard(sr, pid);
            if (found && mwOpen(found)) return;
            /* Nicht im Builder: normaler Link (springt zur Auswahl). */
            link.setAttribute('data-bb-fallback', '');
            link.click();
            link.removeAttribute('data-bb-fallback');
          });
        }, true);

        /* Schon vorab nachladen, sobald Galerie oder Produktreihe in die Nähe kommen,
           damit sich das Popup beim Antippen sofort öffnet. */
        if ('IntersectionObserver' in window) {
          var preIo = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (!en.isIntersecting) return;
              var sr = mwSr();
              if (!sr || !sr.querySelector('.Products-Category__ProductsGrid')) return;
              preIo.unobserve(en.target);
              var pids = [].map.call(en.target.querySelectorAll('[data-bb-pid]'), function (el) { return el.getAttribute('data-bb-pid'); });
              if (pids.length) setTimeout(function () { mwLoadUntil(sr, pids); }, 300);
            });
          }, { rootMargin: '600px 0px' });
          root.querySelectorAll('.bb-adv-gallery, .bb-adv-products').forEach(function (el) {
            if (el.querySelector('[data-bb-pid]')) preIo.observe(el);
          });
        }
      }

      /* „Mein Adventskalender“: Tipp auf Bild oder Titel eines gewählten Teils
         öffnet dasselbe Produkt-Popup wie im Builder. */
      if (root.hasAttribute('data-bb-product-page')) {
        var setupItemPopup = function () {
          var host = document.querySelector('mw-build-offer');
          if (!host || !host.shadowRoot) return false;
          var sr = host.shadowRoot;
          if (!sr.getElementById('bb-mw-item-style')) {
            var st = document.createElement('style');
            st.id = 'bb-mw-item-style';
            st.textContent = '.CartContent-Item--image,.CartContent-Item--productTitle{cursor:pointer;}' +
              /* Kompakte Zeilen, damit der Warenkorb-Button auch auf kleinen Displays sichtbar bleibt:
                 kleineres Bild, kein Leerraum zwischen Titel und Preis, Badge neben dem Streichpreis
                 statt neben dem Titel, flacherer Mengenregler, weniger Abstand zwischen den Zeilen. */
              '.CartContent-Flexy--productsSection.CartContent-Flexy--productsSection{gap:14px !important;}' +
              /* Weniger Leerraum: oben in der Box, unter dem Titel und zwischen Gesamtpreis und Lieferhinweis. */
              /* Schatten rundum gleich stark (App: nur nach unten versetzt, 10 % Deckkraft). */
              '.OfferCart-CartContent__CartContentContainer.OfferCart-CartContent__CartContentContainer{padding-top:14px !important;box-shadow:0 0 14px rgba(0,0,0,.16) !important;}' +
              '.CartContent-Flexy--header.CartContent-Flexy--header{margin-bottom:10px !important;}' +
              '.OfferCart-CartContent__CartContentContainer .CartContent-Flexy--divider{margin-top:10px !important;margin-bottom:10px !important;}' +
              /* Kalender-Grafik reicht bis an die Linie über dem Gesamtpreis. */
              '.CartContent-Flexy--productsSection.CartContent-Flexy--productsSection{margin-bottom:0 !important;}' +
              '.OfferCart-CartContent__CartContentContainer .CartContent-Flexy--divider ~ .CartContent-Flexy--divider{margin-top:0 !important;}' +
              '.CartContent-EmptyItem--iconContainer.CartContent-EmptyItem--iconContainer{background-position:center bottom !important;}' +
              /* Kleiner Abstand unter der Grafik nur, wenn die Liste ganz hineinpasst (nicht scrollt). */
              ':host([data-bb-list-fits]) .OfferCart-CartContent__CartContentContainer .CartContent-Flexy--divider ~ .CartContent-Flexy--divider{margin-top:12px !important;}' +
              '.CartContent-Flexy--priceSection.CartContent-Flexy--priceSection{gap:10px !important;}' +
              '.CartContent-Flexy--priceSection .CartContent-Price__PriceContainer{margin-bottom:0 !important;}' +
              /* Desktop: Die mitlaufende Zusammenfassung höchstens so hoch wie der Bildschirm.
                 Die Produktliste scrollt in sich, Gesamtpreis und Warenkorb-Button bleiben immer sichtbar. */
              '@media (min-width: 990px){' +
              '.OfferCart-CartContent__CartContentContainer.OfferCart-CartContent__CartContentContainer{display:flex !important;flex-direction:column !important;' +
              'max-height:calc(100vh - var(--bb-mw-nav-top,0px) - var(--bb-mw-nav-h,0px) - 36px) !important;}' +
              '.OfferCart-CartContent__CartContentContainer > *{flex:0 0 auto;}' +
              '.CartContent-Flexy--productsSection.CartContent-Flexy--productsSection{flex:1 1 auto !important;min-height:140px;overflow-y:auto !important;' +
              'overscroll-behavior:contain;scrollbar-width:thin;margin-right:-8px;padding-right:8px;}' +
              '}' +
              '.CartContent-Item--itemContainer .CartContent-Item--image{width:64px !important;height:64px !important;flex:0 0 64px !important;object-fit:contain;}' +
              '.CartContent-Item--contentContainer.CartContent-Item--contentContainer{justify-content:flex-start !important;min-width:0;}' +
              '.CartContent-Item--priceSection.CartContent-Item--priceSection{margin-top:4px !important;align-items:center !important;gap:8px;}' +
              '.CartContent-Item--header .CartContent-Item--discountContainer{display:none !important;}' +
              '.CartContent-Item--priceContainer,.CartContent-Item--simplePriceContainer[data-bb-cal]{flex-wrap:wrap !important;row-gap:2px !important;min-width:0;}' +
              /* Preise wie auf den Produktkarten: Kalenderpreis dunkelrot und fett, Streichpreis gleich groß. */
              '.CartContent-Item--priceContainer.CartContent-Item--priceContainer .CartContent-Item--price{font-size:15px !important;font-weight:700 !important;color:var(--bb-calprice,#8B1A1A) !important;}' +
              '.CartContent-Item--priceContainer.CartContent-Item--priceContainer .CartContent-Item--originalPrice{font-size:15px !important;font-weight:400 !important;color:#7C8488 !important;}' +
              '.CartContent-Item--priceContainer:has(.CartContent-Item--originalPrice)::after{' + (typeof BB_BADGE === 'string' ? BB_BADGE :
                'content:var(--bb-mw-badge,"-30%");flex:0 0 auto;align-self:center;margin:0;padding:2px 6px;border-radius:9999px;font-size:11px;font-weight:600;line-height:14px;color:rgb(66,0,0);background:rgb(253,216,216);white-space:nowrap;') + '}' +
              '.CartContent-ItemQuantity--container .CartContent-ItemQuantity--button,.CartContent-ItemQuantity--container .CartContent-ItemQuantity--input{height:32px !important;min-height:0 !important;}' +
              '@media (max-width: 389px){' +
              '.CartContent-Item--itemContainer .CartContent-Item--image{width:52px !important;height:52px !important;flex:0 0 52px !important;}' +
              '.CartContent-Item--priceSection.CartContent-Item--priceSection{gap:6px;}' +
              '.CartContent-ItemQuantity--container .CartContent-ItemQuantity--button,.CartContent-ItemQuantity--container .CartContent-ItemQuantity--input{width:22px !important;min-width:0 !important;}' +
              '}';
            sr.appendChild(st);
          }
          /* Merkt sich am Host, ob die Produktliste vollständig sichtbar ist. Mit 12 px Puffer
             beim Einschalten, damit der Abstand an der Grenze nicht hin- und herspringt. */
          if (!host.hasAttribute('data-bb-fits-ready')) {
            host.setAttribute('data-bb-fits-ready', '');
            var fitsQueued = false;
            var checkFits = function () {
              fitsQueued = false;
              var list = sr.querySelector('.CartContent-Flexy--productsSection');
              var box = sr.querySelector('.OfferCart-CartContent__CartContentContainer');
              if (!list || !box) return;
              var on = host.hasAttribute('data-bb-list-fits');
              var maxH = parseFloat(getComputedStyle(box).maxHeight);
              /* Mobil gibt es keine Höhenbegrenzung: Liste immer vollständig sichtbar. */
              if (isNaN(maxH)) { if (!on) host.setAttribute('data-bb-list-fits', ''); return; }
              if (on && list.scrollHeight > list.clientHeight + 1) host.removeAttribute('data-bb-list-fits');
              else if (!on && box.getBoundingClientRect().height + 12 <= maxH) host.setAttribute('data-bb-list-fits', '');
            };
            var queueFits = function () {
              if (!fitsQueued) { fitsQueued = true; window.requestAnimationFrame(checkFits); }
            };
            new MutationObserver(queueFits).observe(sr, { subtree: true, childList: true });
            window.addEventListener('resize', queueFits);
            queueFits();
          }
          sr.addEventListener('click', function (e) {
            var path = e.composedPath();
            var trigger = false;
            var item = null;
            for (var i = 0; i < path.length; i++) {
              var el = path[i];
              if (!el.classList) continue;
              if (el.classList.contains('CartContent-Item--image') || el.classList.contains('CartContent-Item--productTitle')) trigger = true;
              if (el.classList.contains('CartContent-Item--itemContainer')) { item = el; break; }
            }
            if (!trigger || !item) return;
            var pid = item.getAttribute('data-product-id');
            /* Ein Produkt kann in mehreren Kategorien stehen (z. B. Silber und Halsketten).
               Die App merkt sich die Auswahl je Karte. Deshalb die Karte nehmen, über die das
               Teil hinzugefügt wurde (sie zeigt den Mengenregler), bei Varianten passend zur Größe. */
            var cards = pid ? sr.querySelectorAll('article.Category-ProductCard[id$="-' + pid + '"]') : [];
            var vEl = item.querySelector('.CartContent-Item--variantTitle');
            var vTitle = vEl ? vEl.textContent.trim() : '';
            var card = null, fallback = null;
            for (var c = 0; c < cards.length; c++) {
              if (!cards[c].querySelector('.Category-ProductCard__QuantityContainer')) continue;
              var sel = cards[c].querySelector('select');
              var selText = sel && sel.selectedOptions && sel.selectedOptions[0] ? sel.selectedOptions[0].textContent.trim() : '';
              if (!vTitle || !sel || selText === vTitle) { card = cards[c]; break; }
              if (!fallback) fallback = cards[c];
            }
            card = card || fallback || cards[0] || null;
            var title = card && card.querySelector('.Category-ProductCard__ProductTitle, .Category-ProductCard__ImageContainer');
            if (title) title.click();
          });
          return true;
        };
        if (!setupItemPopup()) {
          var itemTries = 0;
          var itemTimer = setInterval(function () {
            if (setupItemPopup() || ++itemTries > 40) clearInterval(itemTimer);
          }, 250);
        }
      }

      /* Untere Leiste: dieselbe Kalender-Grafik wie in „Mein Adventskalender“ (passt sich dem
         Füllstand an) links in der Leiste anzeigen. */
      if (root.hasAttribute('data-bb-mw-bar-img')) {
        var setupBarImg = function () {
          var aside = document.querySelector('aside.mw-buildoffer');
          var host = document.querySelector('mw-build-offer');
          if (!aside || !host || !host.shadowRoot) return false;
          var sr = host.shadowRoot;
          /* Die Grafik kommt aus eurem Custom CSS in der MW-App: je Füllstand ein Bild am
             leeren Platz, bei vollem Kalender eines an der Produktliste (::after). */
          var findUrl = function () {
            var icon = sr.querySelector('.CartContent-EmptyItem--iconContainer');
            var bg = icon ? getComputedStyle(icon).backgroundImage : '';
            if (bg && bg.indexOf('url(') === 0) return bg;
            var list = sr.querySelector('.CartContent-Flexy--productsSection');
            bg = list ? getComputedStyle(list, '::after').backgroundImage : '';
            if (bg && bg.indexOf('url(') === 0) return bg;
            return '';
          };
          var pending = false;
          var update = function () {
            pending = false;
            var url = findUrl();
            if (url) {
              if (aside.style.getPropertyValue('--bb-bar-img') !== url) aside.style.setProperty('--bb-bar-img', url);
              if (!aside.hasAttribute('data-bb-img')) aside.setAttribute('data-bb-img', '');
            } else if (aside.hasAttribute('data-bb-img')) {
              aside.removeAttribute('data-bb-img');
            }
            var h = Math.round(aside.getBoundingClientRect().height);
            if (h > 0) aside.style.setProperty('--bb-bar-h', h + 'px');
          };
          var request = function () {
            if (!pending) { pending = true; window.requestAnimationFrame(update); }
          };
          new MutationObserver(request).observe(sr, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style'] });
          new MutationObserver(request).observe(aside, { subtree: true, childList: true, characterData: true });
          if (window.ResizeObserver) new ResizeObserver(request).observe(aside);
          /* Tipp auf die Grafik wirkt wie der Button der Leiste. Die Grafik ist ein Hintergrund
             links in der Leiste, daher zählt die Position des Tipps. */
          aside.addEventListener('click', function (e) {
            if (!aside.hasAttribute('data-bb-img') || e.target !== aside) return;
            var r = aside.getBoundingClientRect();
            if (e.clientX - r.left > r.height) return;
            var btn = aside.querySelector('.mw-bundleoffer__button');
            if (btn) btn.click();
          });
          window.addEventListener('resize', request);
          update();
          return true;
        };
        if (!setupBarImg()) {
          var barImgTries = 0;
          var barImgTimer = setInterval(function () {
            if (setupBarImg() || ++barImgTries > 40) clearInterval(barImgTimer);
          }, 250);
        }
      }

      /* Bestätigung beim Hinzufügen: grüner Button „✓ Hinzugefügt“ statt Mengenregler. */
      if (root.hasAttribute('data-bb-mw-added')) {
        var addedLabel = JSON.stringify(root.getAttribute('data-bb-mw-added') || '✓ Hinzugefügt');
        var QC = 'Category-ProductCard__QuantityContainer';
        /* Auf Karte und im Popup statt des Mengenreglers dauerhaft „✓ Hinzugefügt“ zeigen.
           Mengen ändern geht in „Mein Adventskalender“. Der Regler bleibt technisch erhalten,
           ist aber verdeckt und nicht antippbar. */
        var feedbackCss =
          '.' + QC + '{position:relative !important;background:var(--bb-mw-added-bg,#165B33) !important;border-color:var(--bb-mw-added-bg,#165B33) !important;cursor:pointer;}' +
          '.' + QC + ' > *{visibility:hidden !important;}' +
          '.' + QC + '::after{content:var(--bb-mw-added,"✓ Hinzugefügt");position:absolute;inset:0;z-index:5;display:flex;align-items:center;justify-content:center;' +
          'color:#fff;font-size:14px;font-weight:600;white-space:nowrap;pointer-events:none;}' +
          '.' + QC + '[data-bb-added]::after{animation:bbAddedIn .3s ease-out;}' +
          '@keyframes bbAddedIn{from{opacity:0;transform:scale(.9);}to{opacity:1;transform:none;}}';
        /* Produktbild fliegt in die untere Leiste, danach hüpft die Zahl. */
        var bumpCount = function (aside) {
          var badge = aside.querySelector('.mw-bundleoffer__count-badge');
          if (!badge) return;
          var text = badge.textContent || '';
          var m = text.match(/\d+/);
          if (!m) return;
          var r = badge.getBoundingClientRect();
          var cs = getComputedStyle(badge);
          var clone = document.createElement('span');
          clone.className = 'bb-count-clone';
          clone.style.left = r.left + 'px';
          clone.style.top = r.top + 'px';
          clone.style.height = r.height + 'px';
          clone.style.lineHeight = r.height + 'px';
          clone.style.font = cs.font;
          clone.style.letterSpacing = cs.letterSpacing;
          clone.style.color = cs.color;
          var num = document.createElement('b');
          num.textContent = m[0];
          clone.appendChild(document.createTextNode(text.slice(0, m.index)));
          clone.appendChild(num);
          clone.appendChild(document.createTextNode(text.slice(m.index + m[0].length)));
          document.body.appendChild(clone);
          badge.setAttribute('data-bb-hide', '');
          var done = function () {
            clone.remove();
            badge.removeAttribute('data-bb-hide');
          };
          if (num.animate) {
            num.animate([
              { transform: 'scale(1)' },
              { transform: 'scale(1.9)', offset: 0.35 },
              { transform: 'scale(1)' }
            ], { duration: 650, easing: 'ease-out' }).onfinish = done;
          } else {
            setTimeout(done, 650);
          }
        };
        var flyToBar = function (pic) {
          if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          var aside = document.querySelector('aside.mw-buildoffer');
          if (!aside || document.documentElement.classList.contains('bb-mw-bar-hidden')) return;
          var ar = aside.getBoundingClientRect();
          if (ar.height === 0 || ar.top >= window.innerHeight) return;
          var src = pic.currentSrc || pic.src;
          var from = pic.getBoundingClientRect();
          if (!src || from.width === 0) return;
          var badge = aside.querySelector('.mw-bundleoffer__count-badge') || aside;
          var to = badge.getBoundingClientRect();
          if (aside.hasAttribute('data-bb-img')) {
            /* Ziel ist die Kalender-Grafik links in der Leiste. */
            var bh = ar.height;
            to = { left: ar.left + bh / 2 - 10, top: ar.top, height: bh };
          }
          var size = Math.min(from.width, from.height, 220);
          var startX = from.left + from.width / 2 - size / 2;
          var startY = from.top + from.height / 2 - size / 2;
          var endX = to.left + 10 - (startX + size / 2);
          var endY = to.top + to.height / 2 - (startY + size / 2);
          var img = document.createElement('img');
          img.className = 'bb-fly-img';
          img.src = src;
          img.alt = '';
          img.style.left = startX + 'px';
          img.style.top = startY + 'px';
          img.style.width = size + 'px';
          img.style.height = size + 'px';
          document.body.appendChild(img);
          if (!img.animate) { img.remove(); return; }
          var anim = img.animate([
            { transform: 'translate(0, 0) scale(1)', opacity: 1 },
            { transform: 'translate(' + endX * 0.45 + 'px, ' + (endY * 0.45 - 80) + 'px) scale(.55)', opacity: 1, offset: 0.45 },
            { transform: 'translate(' + endX + 'px, ' + endY + 'px) scale(.08)', opacity: 0.3 }
          ], { duration: 750, easing: 'cubic-bezier(.45, 0, .55, 1)', fill: 'forwards' });
          anim.onfinish = function () {
            img.remove();
            bumpCount(aside);
          };
        };
        var feedbackHosts = {};
        var attachFeedback = function (tag, containerSel) {
          if (feedbackHosts[tag]) return true;
          var host = document.querySelector(tag);
          if (!host || !host.shadowRoot) return false;
          feedbackHosts[tag] = true;
          var sr = host.shadowRoot;
          var st = document.createElement('style');
          st.textContent = feedbackCss;
          sr.appendChild(st);
          host.style.setProperty('--bb-mw-added', addedLabel);
          host.style.setProperty('--bb-mw-added-bg', root.getAttribute('data-bb-mw-added-bg') || '#165B33');
          var last = { box: null, at: 0 };
          /* Tipp auf den grünen „✓ Hinzugefügt“-Button nimmt das Teil wieder heraus.
             Technisch: Minus im verdeckten Mengenregler auslösen. */
          sr.addEventListener('click', function (e) {
            var path = e.composedPath();
            var qcEl = null;
            for (var q = 0; q < path.length; q++) {
              if (path[q].classList && path[q].classList.contains(QC)) { qcEl = path[q]; break; }
            }
            if (!qcEl) return;
            /* Unser eigener Klick auf das Minus muss bei der App ankommen. */
            if (path[0] && path[0].tagName === 'BUTTON') return;
            e.preventDefault();
            e.stopPropagation();
            var minus = qcEl.querySelector('button');
            if (minus && !minus.disabled) minus.click();
          }, true);
          /* Nur nach einem echten Tipp auf „In den Kalender“, nicht beim Laden oder Öffnen. */
          sr.addEventListener('click', function (e) {
            var path = e.composedPath();
            var btn = null;
            for (var i = 0; i < path.length; i++) {
              if (path[i].tagName === 'BUTTON') { btn = path[i]; break; }
            }
            if (!btn || btn.disabled || !btn.classList.contains('Category-ProductCard__Button')) return;
            var box = btn.closest(containerSel);
            if (box) {
              last.box = box; last.at = Date.now();
              if (root.hasAttribute('data-bb-mw-fly')) {
                var art = btn.closest('article');
                var pic = art ? art.querySelector('.Category-ProductCard__ImageContainer img')
                              : sr.querySelector('.Products-ProductInfoModal--modalImage');
                if (pic) flyToBar(pic);
              }
            }
          }, true);
          var pending = false;
          new MutationObserver(function () {
            if (pending) return;
            pending = true;
            window.requestAnimationFrame(function () {
              pending = false;
              if (!last.box || Date.now() - last.at > 2000) return;
              var qc = last.box.querySelector('.' + QC);
              if (!qc) return;
              last.box = null;
              qc.setAttribute('data-bb-added', '');
              setTimeout(function () { qc.removeAttribute('data-bb-added'); }, 1250);
            });
          }).observe(sr, { subtree: true, childList: true });
          return true;
        };
        var attachAllFeedback = function () {
          var a = attachFeedback('mw-build-offer', '.Category-ProductCard__BottomSection');
          var b = attachFeedback('mw-offers-dialog', '.Products-ProductInfoModal--modalActions');
          return a && b;
        };
        if (!attachAllFeedback()) {
          var fbTries = 0;
          var fbTimer = setInterval(function () {
            if (attachAllFeedback() || ++fbTries > 40) clearInterval(fbTimer);
          }, 250);
          var onFbClick = function () {
            setTimeout(function () {
              if (attachAllFeedback()) document.removeEventListener('click', onFbClick, true);
            }, 50);
          };
          document.addEventListener('click', onFbClick, true);
        }

      }

      /* „In den Warenkorb“ vor vollem Kalender: Button nennt die fehlende Anzahl, ein Tipp
         darauf hebt den Hinweis „Füge noch … hinzu“ hervor. */
      if (root.hasAttribute('data-bb-mw-cart-hint')) {
        var hintOne = root.getAttribute('data-bb-mw-cart-hint-one') || '';
        var hintMany = root.getAttribute('data-bb-mw-cart-hint') || '';
        var setupCartHint = function () {
          var host = document.querySelector('mw-build-offer');
          if (!host || !host.shadowRoot) return false;
          var sr = host.shadowRoot;
          var st = document.createElement('style');
          st.textContent =
            '.CartContent-AddToCartButton__ButtonDisabled[data-bb-left]{pointer-events:none;}' +
            '.CartContent-AddToCartButton__ButtonDisabled[data-bb-left] .CartContent-AddToCartButton__ButtonText{display:none !important;}' +
            '.CartContent-AddToCartButton__ButtonDisabled[data-bb-left]::after{content:attr(data-bb-left);position:relative;z-index:1;}' +
            '.CartContent-EmptyItem--title[data-bb-attn]{animation:bbAttn .6s ease;color:var(--bb-calprice,#8B1A1A) !important;}' +
            '.CartContent-EmptyItem--title{transition:color .4s ease;}' +
            '@keyframes bbAttn{0%,100%{transform:none;}20%{transform:translateX(-6px);}40%{transform:translateX(6px);}60%{transform:translateX(-4px);}80%{transform:translateX(4px);}}' +
            '@media (prefers-reduced-motion: reduce){.CartContent-EmptyItem--title[data-bb-attn]{animation:none;}}';
          sr.appendChild(st);

          var pending = false;
          var label = function () {
            pending = false;
            var btn = sr.querySelector('.mw-build-offer-add-to-cart.CartContent-AddToCartButton__ButtonDisabled');
            var all = sr.querySelectorAll('.mw-build-offer-add-to-cart');
            for (var i = 0; i < all.length; i++) {
              if (all[i] !== btn && all[i].hasAttribute('data-bb-left')) all[i].removeAttribute('data-bb-left');
            }
            if (!btn) return;
            /* Fehlende Anzahl aus dem Hinweis der App („Füge noch 3 …“). Der gibt es mobil und
               am Desktop, die untere Leiste gibt es am Desktop nicht. */
            var hintEl = sr.querySelector('.CartContent-EmptyItem--title');
            var hm = hintEl ? (hintEl.textContent || '').match(/noch\s*(\d+)/i) : null;
            var left = hm ? parseInt(hm[1], 10) : 0;
            if (!hm) {
              var aside = document.querySelector('aside.mw-buildoffer');
              var m = aside ? (aside.textContent || '').match(/(\d+)\s*von\s*(\d+)/) : null;
              left = m ? parseInt(m[2], 10) - parseInt(m[1], 10) : 0;
            }
            if (left <= 0) { btn.removeAttribute('data-bb-left'); return; }
            var text = (left === 1 ? hintOne : hintMany).replace('[n]', left);
            if (text && btn.getAttribute('data-bb-left') !== text) btn.setAttribute('data-bb-left', text);
          };
          var request = function () {
            if (!pending) { pending = true; window.requestAnimationFrame(label); }
          };
          new MutationObserver(request).observe(sr, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
          var bar = document.querySelector('aside.mw-buildoffer');
          if (bar) new MutationObserver(request).observe(bar, { subtree: true, childList: true, characterData: true });
          label();

          /* Der ausgegraute Button nimmt keine Klicks an. Wir prüfen die Position des Tipps. */
          sr.addEventListener('click', function (e) {
            var btn = sr.querySelector('.mw-build-offer-add-to-cart.CartContent-AddToCartButton__ButtonDisabled');
            if (!btn) return;
            var r = btn.getBoundingClientRect();
            if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return;
            var hint = sr.querySelector('.CartContent-EmptyItem--title');
            if (!hint) return;
            var hr = hint.getBoundingClientRect();
            if (hr.top < 0 || hr.bottom > window.innerHeight) hint.scrollIntoView({ behavior: 'smooth', block: 'center' });
            hint.removeAttribute('data-bb-attn');
            void hint.offsetWidth;
            hint.setAttribute('data-bb-attn', '');
            clearTimeout(hint._bbT);
            hint._bbT = setTimeout(function () { hint.removeAttribute('data-bb-attn'); }, 1600);
          }, true);
          return true;
        };
        if (!setupCartHint()) {
          var hintTries = 0;
          var hintTimer = setInterval(function () {
            if (setupCartHint() || ++hintTries > 40) clearInterval(hintTimer);
          }, 250);
        }
      }

      /* Kalender voll: Die App graut alle „Hinzufügen“-Buttons aus. Wir zeigen
         stattdessen „Kalender voll“ und springen beim Tippen zur Zusammenfassung. */
      if (root.hasAttribute('data-bb-mw-full-label')) {
        var fullLabel = root.getAttribute('data-bb-mw-full-label');
        var setupMwFull = function () {
          var host = document.querySelector('mw-build-offer');
          if (!host || !host.shadowRoot) return false;
          var sr = host.shadowRoot;
          if (!sr.querySelector('.Category-ProductCard__Button')) return false;
          if (!sr.getElementById('bb-mw-full-style')) {
            var st = document.createElement('style');
            st.id = 'bb-mw-full-style';
            st.textContent =
              ':host([data-bb-full]) button.Category-ProductCard__ButtonDisabled{pointer-events:none;}' +
              ':host([data-bb-full]) .Category-ProductCard__BottomSection:has(button.Category-ProductCard__ButtonDisabled){cursor:pointer;}' +
              ':host([data-bb-full]) button.Category-ProductCard__ButtonDisabled .Category-ProductCard__ButtonText{display:none !important;}' +
              ':host([data-bb-full]) button.Category-ProductCard__ButtonDisabled::after{content:var(--bb-mw-full-label,"Kalender voll");}';
            sr.appendChild(st);
          }
          host.style.setProperty('--bb-mw-full-label', JSON.stringify(fullLabel));

          var ticking = false;
          var jumpToSummary = function () {
            var barBtn = document.querySelector('aside.mw-buildoffer .mw-bundleoffer__button');
            if (barBtn && barBtn.getBoundingClientRect().height > 0 && getComputedStyle(barBtn).visibility !== 'hidden') {
              barBtn.click();
              return;
            }
            var target = sr.querySelector('.CartContent-Flexy--header');
            if (!target) return;
            var r = target.getBoundingClientRect();
            if (r.top < 0 || r.top > window.innerHeight * 0.6) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          };

          /* Dasselbe im Produkt-Popup: „Kalender voll“ statt ausgegrautem Button,
             ein Tipp schließt das Popup und springt zur Zusammenfassung. */
          var dialogReady = false;
          var attachDialogFull = function () {
            if (dialogReady) return;
            var dHost = document.querySelector('mw-offers-dialog');
            if (!dHost || !dHost.shadowRoot) return;
            dialogReady = true;
            var dsr = dHost.shadowRoot;
            var dst = document.createElement('style');
            dst.textContent =
              ':host([data-bb-full]) .Products-ProductInfoModal--modalActions button.Category-ProductCard__ButtonDisabled{pointer-events:none;}' +
              ':host([data-bb-full]) .Products-ProductInfoModal--modalActions:has(button.Category-ProductCard__ButtonDisabled){cursor:pointer;}' +
              ':host([data-bb-full]) .Products-ProductInfoModal--modalActions button.Category-ProductCard__ButtonDisabled .Category-ProductCard__ButtonText{display:none !important;}' +
              ':host([data-bb-full]) .Products-ProductInfoModal--modalActions button.Category-ProductCard__ButtonDisabled::after{content:var(--bb-mw-full-label,"Kalender voll");}';
            dsr.appendChild(dst);
            dHost.style.setProperty('--bb-mw-full-label', JSON.stringify(fullLabel));
            dsr.addEventListener('click', function (e) {
              if (!dHost.hasAttribute('data-bb-full')) return;
              var path = e.composedPath();
              var actions = null;
              for (var i = 0; i < path.length; i++) {
                if (path[i].classList && path[i].classList.contains('Products-ProductInfoModal--modalActions')) { actions = path[i]; break; }
              }
              if (!actions || !actions.querySelector('button.Category-ProductCard__ButtonDisabled')) return;
              e.preventDefault();
              var close = dsr.querySelector('.Products-ProductInfoModal--modalCloseButton');
              if (close) close.click();
              setTimeout(jumpToSummary, 350);
            }, true);
          };

          var check = function () {
            ticking = false;
            var anyEnabled = sr.querySelector('button.Category-ProductCard__ButtonEnabled');
            var anyDisabled = sr.querySelector('button.Category-ProductCard__ButtonDisabled');
            var full = !!(anyDisabled && !anyEnabled);
            if (full) host.setAttribute('data-bb-full', '');
            else host.removeAttribute('data-bb-full');
            attachDialogFull();
            var dHost = document.querySelector('mw-offers-dialog');
            if (dHost) {
              if (full) dHost.setAttribute('data-bb-full', '');
              else dHost.removeAttribute('data-bb-full');
            }
          };
          var request = function () {
            if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
          };
          check();
          new MutationObserver(request).observe(sr, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'disabled'] });

          sr.addEventListener('click', function (e) {
            if (!host.hasAttribute('data-bb-full')) return;
            var path = e.composedPath();
            var hit = null;
            for (var i = 0; i < path.length; i++) {
              var el = path[i];
              if (el.classList && el.classList.contains('Category-ProductCard__BottomSection')) { hit = el; break; }
            }
            if (!hit || !hit.querySelector('button.Category-ProductCard__ButtonDisabled')) return;
            e.preventDefault();
            jumpToSummary();
          });
          return true;
        };
        if (!setupMwFull()) {
          var fullTries = 0;
          var fullTimer = setInterval(function () {
            if (setupMwFull() || ++fullTries > 40) clearInterval(fullTimer);
          }, 250);
        }
      }

      var bar = root.querySelector('[data-bb-bar]');
      var hero = root.querySelector('[data-bb-hero]') || root.firstElementChild;
      if (bar && hero && 'IntersectionObserver' in window) {
        var link = bar.querySelector('a');
        new IntersectionObserver(function (entries) {
          var show = !entries[0].isIntersecting;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (link) link.setAttribute('tabindex', show ? '0' : '-1');
        }, { threshold: 0 }).observe(hero);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-bb-adv]').forEach(initBbAdv);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
